import React, { useState } from "react";

import Members from "../../molecules/members/members";
import ClubActivity from "../club-activity/clubActivity";
import ClubBookshelves from "../club-bookshelves/clubBookshelves";
import ClubDescription from "../club-description/clubDescription";
import MemberGrid from "../members-grid/memberGrid";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./clubDetail.scss";

const ClubDetail = (props: ReferenciaContenido) => {
  const { referenciaTabsContenido = [] } = props;

  const [tabSelected, setTabSelected] = useState(0);

  return (
    <div className="o-club-detail">
      <div className="o-club-detail__top-divider"></div>
      <ul className="o-club-detail__tabs">
        {referenciaTabsContenido.map((tab, tabIndex) => (
          <li
            key={tabIndex}
            className={`o-club-detail__tabs__tab 
              ${
                tabSelected === tabIndex
                  ? "o-club-detail__tabs__tab-selected"
                  : ""
              } 
              gtm${normalizeTwoWords(
                props.nombreCategoria
              )}TabsClub${normalizeTwoWords(tab.nombreTab)}`}
            onClick={() => setTabSelected(tabIndex)}
          >
            {tab.nombreTab}
          </li>
        ))}
      </ul>
      <div
        className={`o-club-detail__content 
          ${tabSelected === 0 ? "o-club-detail__content--active" : ""}`}
      >
        <ClubDescription {...referenciaTabsContenido[0]} />
        {referenciaTabsContenido[0].referenciaContenido &&
          referenciaTabsContenido[0].referenciaContenido.length > 1 && (
            <ClubActivity
              {...referenciaTabsContenido[0]}
              category={props.nombreCategoria}
            />
          )}
        {referenciaTabsContenido[0].referenciaContenido &&
          referenciaTabsContenido[0].referenciaContenido[5] && (
            <Members {...referenciaTabsContenido[0].referenciaContenido[5]} />
          )}
      </div>
      {referenciaTabsContenido[1] && (
        <div
          className={`o-club-detail__content 
            ${tabSelected === 1 ? "o-club-detail__content--active" : ""}`}
        >
          <ClubBookshelves
            {...referenciaTabsContenido[1]}
            categoryName={props.nombreCategoria}
          />
        </div>
      )}
      {referenciaTabsContenido[2] &&
        referenciaTabsContenido[2].referenciaContenido[0] && (
          <div
            className={`o-club-detail__content 
            ${tabSelected === 2 ? "o-club-detail__content--active" : ""}`}
          >
            <MemberGrid
              {...referenciaTabsContenido[2].referenciaContenido[0]}
            />
          </div>
        )}
    </div>
  );
};

export default ClubDetail;
